export default "__VITE_ASSET__wU4_6C4___"